<template>
  <div class="watermark-container">
    <div class="watermark-content" ref="watermarkContent">
      <span class="watermark-text">{{ text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Watermark',
  data(){
    return {
      text:''
    }
  },
  mounted() {
    if (sessionStorage.getItem('userInfo')) {
      const nickName = JSON.parse(sessionStorage.getItem('userInfo')).nickName
      const phonenumber = JSON.parse(sessionStorage.getItem('userInfo')).phonenumber
      // 对phonenumber 进行脱敏操作
      const reg = /^(\d{3})\d{4}(\d{4})$/
      const newPhonenumber = phonenumber.replace(reg, '$1****$2')
      this.text = nickName + ' ' + newPhonenumber
    } else {
      this.text = ''
    }
    this.addWatermark();
    window.addEventListener('resize', this.addWatermark);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.addWatermark);
  },
  methods: {
    addWatermark() {
      const watermarkContent = this.$refs.watermarkContent;
      const width = window.innerWidth;
      const height = window.innerHeight;
      const isMobile = width <= 768; // 判断是否为移动端
      const fontSize = isMobile ? 16 : 20; // 移动端和桌面端不同的字体大小
      const angle = -30;
      const text = this.text;

      // 清空之前的水印
      watermarkContent.innerHTML = '';

      // 创建一个虚拟的div用于排版
      const virtualDiv = document.createElement('div');
      virtualDiv.style.width = `${width}px`;
      virtualDiv.style.height = `${height}px`;
      virtualDiv.style.position = 'relative';
      virtualDiv.style.display = 'flex';
      virtualDiv.style.flexWrap = 'wrap';

      // 创建水印文本
      const count = isMobile ? 200 : 500; // 移动端和桌面端不同的水印数量
      for (let i = 0; i < count; i++) {
        const watermarkSpan = document.createElement('span');
        watermarkSpan.textContent = text;
        watermarkSpan.className = 'watermark-text';
        watermarkSpan.style.transform = `rotate(${angle}deg)`;
        watermarkSpan.style.fontSize = `${fontSize}px`;
        watermarkSpan.style.margin = `${Math.random() * 50}px`; // 调整随机间距以适应移动端
        watermarkSpan.style.opacity = '0.2'; // 设置透明度
        watermarkSpan.style.color = '#cccccc'; // 设置浅颜色
        virtualDiv.appendChild(watermarkSpan);
      }

      // 添加虚拟div的内容到水印容器
      watermarkContent.appendChild(virtualDiv);
    }
  }
};
</script>

<style scoped>
.watermark-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: 10000;
  overflow: hidden;
}

.watermark-content {
  width: 100%;
  height: 100%;
  position: relative;
}

.watermark-text {
  user-select: none;
  white-space: nowrap;
}
</style>

